import request, { post } from '@/utils/request';
//获取日志列表
export function getLogList(params) {
  return request({
    url: '/system/getLogList',
    method: 'post',
    params: params
  });
}
//密码修改
export function updatePassword(data) {
  return request({
    url: '/system/updatePassword',
    method: 'post',
    data: data
  });
}
export function resetPwd(id) {
  return post("/system/basic/resetSecret", {
    id: id
  }, true);
}
//密码修改
export function getRoleList(data) {
  return request({
    url: '/system/getRoleList',
    method: 'post',
    data: data
  });
}
//添加角色
export function addRole(params) {
  return request({
    url: '/system/addRole',
    method: 'post',
    params: params
  });
}
//修改角色
export function updateRole(params) {
  return request({
    url: '/system/updateRole',
    method: 'post',
    params: params
  });
}
//删除角色
export function deleteRole(params) {
  return request({
    url: '/system/deleteRole',
    method: 'post',
    params: params
  });
}
//删除角色
export function getMenuList() {
  return request({
    url: '/system/getMenuList',
    method: 'post'
  });
}
//添加权限
export function addMenu(data) {
  return request({
    url: '/system/addMenu',
    method: 'post',
    data: data
  });
}
//删除权限
export function deletePermission(params) {
  return request({
    url: '/system/deleteMenu',
    method: 'post',
    params: params
  });
}
//修改权限
export function updateMenu(data) {
  return request({
    url: '/system/updateMenu',
    method: 'post',
    data: data
  });
}
//获取分配权限列表
export function getRolePermission(params) {
  return request({
    url: '/system/getMenus',
    method: 'post',
    params: params
  });
}
//给角色分配权限
export function bindRolePermission(data) {
  return request({
    url: '/system/bindMenu',
    method: 'post',
    data: data
  });
}
//操作员绑定角色
export function bindRole(data) {
  return request({
    url: '/system/bindRole',
    method: 'post',
    data: data
  });
}
//获取分配角色列表
export function getEmployeesRoles(params) {
  return request({
    url: '/system/getRoles',
    method: 'post',
    params: params
  });
}
//获取操作员列表
export function getOperate(params) {
  return request({
    url: '/system/basic/getOperate',
    method: 'post',
    params: params
  });
}